import { selectors as wifi } from './slices/settings/wifiSlice';
import { selectors as networkAccess } from './slices/settings/networkAccessSlice';
import { selectors as pods } from './slices/settings/podsSlice';
import { selectors as securityPolicy } from './slices/settings/securityPolicySlice';
import { selectors as employeeLogin } from './slices/settings/employeeLoginSlice';
import { selectors as blockedEmployees } from './slices/settings/blockedEmployeesSlice';

import { selectors as devicesAndGroups } from './slices/ui/devicesAndGroupsSlice';
import { selectors as page } from './slices/ui/pageSlice';
import { selectors as miniBanner } from './slices/ui/miniBanner';
import { selectors as errorAlert } from './slices/ui/errorAlertSlice';

import { selectors as deviceGroups } from './slices/zones/deviceGroupsSlice';
import { selectors as employeeGroupShareAccess } from './slices/zones/shareAccessSlice';
import { selectors as devices } from './slices/zones/devicesSlice';

import { selectors as defaultDailyDataUsage } from './slices/dataUsage/default/dailySlice';
import { selectors as employeeDailyDataUsage } from './slices/dataUsage/employee/dailySlice';
import { selectors as guestDailyDataUsage } from './slices/dataUsage/guest/dailySlice';

import { selectors as defaultMonthlyDataUsage } from './slices/dataUsage/default/monthlySlice';
import { selectors as employeeMonthlyDataUsage } from './slices/dataUsage/employee/monthlySlice';
import { selectors as guestMonthlyDataUsage } from './slices/dataUsage/guest/monthlySlice';

import { selectors as guestDailyOnlineTime } from './slices/onlineTime/guest/dailyOnlineTimeSlice';
import { selectors as guestMonthlyOnlineTime } from './slices/onlineTime/guest/monthlyOnlineTimeSlice';
import { selectors as personsDailyOnlineTime } from './slices/onlineTime/persons/dailyOnlineTimeSlice';
import { selectors as personsMonthlyOnlineTime } from './slices/onlineTime/persons/monthlyOnlineTimeSlice';

import { selectors as personsMonthlyAppsOnlineTime } from './slices/onlineTime/persons/monthlyAppsOnlineTimeSlice';
import { selectors as personsLast12MonthsAppsOnlineTime } from './slices/onlineTime/persons/last12monthsAppsOnlineTimeSlice';

import { selectors as personDailyDataUsage } from './slices/dataUsage/person/dailySlice';
import { selectors as personMonthlyDataUsage } from './slices/dataUsage/person/monthlySlice';
import { selectors as deviceDailyOnlineTime } from './slices/onlineTime/device/dailyDeviceOnlineTimeSlice';
import { selectors as deviceMonthlyOnlineTime } from './slices/onlineTime/device/monthlyDeviceOnlineTimeSlice';

import { selectors as deviceDailyDataUsage } from './slices/dataUsage/device/dailySlice';
import { selectors as deviceMonthlyDataUsage } from './slices/dataUsage/device/monthlySlice';

import { selectors as guestDailyAppsOnlineTime } from './slices/appsOnlineTime/guest/dailyAppsOnlineTimeSlice';
import { selectors as guestMonthlyAppsOnlineTime } from './slices/appsOnlineTime/guest/monthlyAppsOnlineTimeSlice';
import { selectors as employeeMonthlyAppsOnlineTime } from './slices/appsOnlineTime/employee/monthlyAppsOnlineTimeSlice';
import { selectors as defaultMonthlyAppsOnlineTime } from './slices/appsOnlineTime/default/monthlyAppsOnlineTimeSlice';
import { selectors as guestLast12MonthsAppsOnlineTime } from './slices/appsOnlineTime/guest/last12MonthsAppsOnlineTimeSlice';
import { selectors as employeeLast12MonthsAppsOnlineTime } from './slices/appsOnlineTime/employee/last12MonthsAppsOnlineTimeSlice';
import { selectors as defaultLast12MonthsAppsOnlineTime } from './slices/appsOnlineTime/default/last12MonthsAppsOnlineTimeSlice';

export const settings = {
  wifi,
  networkAccess,
  pods,
  securityPolicy,
  employeeLogin,
  blockedEmployees,
};
export const ui = { devicesAndGroups, page, miniBanner, errorAlert };
export const zones = { devices, deviceGroups, employeeGroupShareAccess };

export const dataUsage = {
  default: {
    daily: defaultDailyDataUsage,
    monthly: defaultMonthlyDataUsage,
  },
  employee: {
    daily: employeeDailyDataUsage,
    monthly: employeeMonthlyDataUsage,
  },
  guest: {
    daily: guestDailyDataUsage,
    monthly: guestMonthlyDataUsage,
  },
  person: {
    daily: personDailyDataUsage,
    monthly: personMonthlyDataUsage,
  },
  device: {
    daily: deviceDailyDataUsage,
    monthly: deviceMonthlyDataUsage,
  },
};

export const onlineTime = {
  guest: {
    daily: guestDailyOnlineTime,
    monthly: guestMonthlyOnlineTime,
  },
  persons: {
    daily: personsDailyOnlineTime,
    monthly: personsMonthlyOnlineTime,
  },
  device: {
    daily: deviceDailyOnlineTime,
    monthly: deviceMonthlyOnlineTime,
  },
};

export const appsOnlineTime = {
  persons: {
    monthly: personsMonthlyAppsOnlineTime,
    last12months: personsLast12MonthsAppsOnlineTime,
  },
  guest: {
    daily: guestDailyAppsOnlineTime,
    monthly: guestMonthlyAppsOnlineTime,
    last12months: guestLast12MonthsAppsOnlineTime,
  },
  employee: {
    monthly: employeeMonthlyAppsOnlineTime,
    last12months: employeeLast12MonthsAppsOnlineTime,
  },
  default: {
    monthly: defaultMonthlyAppsOnlineTime,
    last12months: defaultLast12MonthsAppsOnlineTime,
  },
  // persons: {
  //   // daily: personsDailyOnlineTime,
  //   monthly: personsMonthlyAppsOnlineTime,
  // },
  // device: {
  //   daily: deviceDailyOnlineTime,
  //   monthly: deviceMonthlyOnlineTime,
  // },
};

export { selectors as debug } from './slices/debugSlice';
export { selectors as build } from './slices/buildSlice';
export { selectors as auth } from './slices/authSlice';
export { selectors as magicLink } from './slices/magicLinkSlice';
export { selectors as customer } from './slices/customerSlice';
export { selectors as employees } from './slices/employeesSlice';
export { selectors as employee } from './slices/employeeSlice';
export { selectors as speedTest } from './slices/speedTestSlice';
export { selectors as locations } from './slices/locationsSlice';
export { selectors as locationAppTime } from './slices/locationAppTimeSlice';
export { selectors as locationAtWorkEvents } from './slices/locationAtWorkEventsSlice';
export { selectors as deviceSecurityPolicy } from './slices/deviceSecurityPolicySlice';
export { selectors as personSecurityPolicy } from './slices/personSecurityPolicySlice';
export { selectors as guestNetworkUsage } from './slices/guestNetworkUsageSlice';
export { selectors as guests } from './slices/guestsSlice';
export { selectors as guestEmailCollection } from './slices/guestEmailCollectionSlice';
export { selectors as securityEvents } from './slices/securityEvents';
export { selectors as deviceSecurityEvents } from './slices/deviceSecurityEventsSlice';
export { selectors as employeeSecurityEvents } from './slices/employeeSecurityEventsSlice';
export { selectors as topology } from './slices/topologySlice';
export { selectors as customerSupportConfigurations } from './slices/customerSupportConfigurations';
export { selectors as device } from './slices/deviceSlice';
export { selectors as pubNub } from './slices/pubNubSlice';
export { selectors as globalAuthLoginOptions } from './slices/globalAuthLoginOptionsSlice';
export { selectors as applicationInfo } from './slices/applicationInfoSlice';
export { selectors as locationCapabilities } from './slices/locationCapabilitiesSlice';
